import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../lib/auth-store";

export function ProtectedRoute() {
  const fbUser = useAuthStore((s) => s.fbUser);
  if (!fbUser) return <Navigate to="/login" replace />;
  return <Outlet />;
}
